Vue.component('ack-product-scrolling-content', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-scrolling-content',
	props: {
		scrollingItems: {
			// :product-info
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: false,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		desHyperLink: {
			type: Object,
			required: false,
			default: () => ({
				hyperLink: '',
			}),
		},
		currentPageId: {
			type: String,
			required: false,
		},
		productHandle: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			solSeBuildPlatforms: [
				{
					title: 'Large Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Large_Beige_Model_2.png?v=1782202363',
					mediaBgColor: '#E9EFF4',
					accentColor: '#3a8dde',
					points: [
						'Ideal for printing dental models and multiple full-arch indications.',
						'Ability to print multiple applications for high-volume workloads.',
						'Print area: 5.1 x 3.1 x 4.7 in / 12.9 x 8 x 12 cm',
					],
				},
				{
					title: 'Medium Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Medium_with_Splint.png?v=1782202362',
					mediaBgColor: '#EEF3EE',
					accentColor: '#2aa6a1',
					points: [
						'Ideal for 3D printing single full-arch or smaller indications with enhanced print efficiency.',
						'A perfect balance between productivity and resin efficiency.',
						'Print area: 2.7 x 2.7 x 4.7 in / 7 x 7 x 12 cm',
					],
				},
				{
					title: 'Small Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Small_with_crown.png?v=1782202362',
					mediaBgColor: '#F0EDF8',
					accentColor: '#ab65f4',
					points: [
						'Perfect for printing crowns, bridges, surgical guides, castable crowns and gingiva masks.',
						'Allows minimal resin displacement for faster layer settling.',
						'Print area: 1.5 x 0.7 x 4.7 in / 4 x 2 x 12 cm',
					],
				},
			],
			solPlusFeatureImages: [
				{
					title: 'Standard Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Plus_Launch_Presentation-07.png?v=1782354940',
					alt: 'Standard Build Platform',
					mediaBgColor: '#E9EFF4',
					accentColor: '#3a8dde',
					points: [
						'Ideal for printing multiple dental models, denture bases, and full-arch indications in a single print run.',
						'Recommended for high-volume workflows, with capacity for up to 8 models printed horizontally.',
						'Print area: 8.6 x 5 x 4.7 in / 21.8 x 12.7 x 12 cm.',
					],
					imageMaxWidth: '82%',
					imageMaxHeight: '82%',
					panelHeight: '260px',
					mediaPadding: '1.5rem',
					imageScale: '1',
					imageOnLeft: true,
				},
				{
					title: 'Arch Build Platform',
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch.png?v=1782354936',
					alt: 'Arch Build Platform',
					mediaBgColor: '#EEF3EE',
					accentColor: '#33b2ad',
					points: [
						'Ideal for situations when faster turnaround is preferred, with capacity of up to 3 models printed horizontally.',
						'Compact print area helps reduce resin displacement and shorten wait times between layers for faster printing.',
						'Print area: 5.5 x 3.4 x 4.7 in / 14 x 8.8 x 12 cm',
					],
					imageMaxWidth: '100%',
					imageMaxHeight: '100%',
					panelHeight: '260px',
					mediaPadding: '0.5rem',
					imageScale: '1.18',
					imageLarge: true,
					imageOnLeft: false,
				},
			],
			solPlusArchKitIntro: {
				image:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch_Kit_Top_banner-17.png?v=1790735341',
				imageAlt: 'SOL Plus printer with Arch Kit',
				logo:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Plus_V4_Logo.png?v=1707214839',
				logoAlt: 'SOL Plus',
				title: 'Arch Kit',
				subtitleLines: ['Smaller batches.', 'Faster turnaround.'],
				description:
					'Turn your SOL Plus into a compact arch printer for individual arches, All-on-X cases, and small batches, with no second printer needed.',
			},
			solPlusArchKitStats: [
				{
					icon:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch_Kit_Icon_1.png?v=1790735339',
					iconAlt: 'Print time',
					metric: '35 MIN',
					title: 'Up to 60% shorter\nprint times',
					note: 'Print average-size All-on-X cases in about 35 minutes instead of 90.',
					noteIsSmall: true,
				},
				{
					icon:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch_Kit_Icon_2.png?v=1790735339',
					iconAlt: 'Dental arches',
					metric: '3 ARCHES',
					title: 'Print Up to\n3 Full Arches at Once',
					note: 'Print up to 3 full arches horizontally in a single run.',
					noteIsSmall: false,
				},
				{
					icon:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch_Kit_Icon_3.png?v=1790735339',
					iconAlt: 'Resin bottle',
					metric: 'LESS RESIN',
					title: 'Less resin\nto get started',
					note: 'Use less resin for small jobs and reduce setup costs.',
					noteIsSmall: false,
				},
			],
			solPlusArchKitWorkflow: {
				image:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch_Kit_Banner.png?v=1790735341',
				imageAlt: 'One printer, two workflows. Flexibility when your workflow demands it.',
			},
			solPlusArchKitIncludesTitle: 'Kit Includes',
			solPlusArchKitIncludes: [
				{
					title: 'Arch Build Platform',
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP.png?v=1790735340',
				},
				{
					title: 'Arch Vat',
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Vat.png?v=1790735340',
				},
				{
					title: 'Arch Heating Rod',
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Heater.png?v=1790735340',
				},
			],
		};
	},
});
